const KPI_BUILDER_COLLAPSED_KEY = "pivony_kpi_builder_collapsed";

export function loadKpiBuilderCollapsed(defaultCollapsed = true) {
  try {
    const raw = localStorage.getItem(KPI_BUILDER_COLLAPSED_KEY);
    if (raw === "0") return false;
    if (raw === "1") return true;
  } catch (_) {
    /* ignore */
  }
  return defaultCollapsed;
}

export function saveKpiBuilderCollapsed(collapsed) {
  try {
    localStorage.setItem(KPI_BUILDER_COLLAPSED_KEY, collapsed ? "1" : "0");
  } catch (_) {
    /* ignore */
  }
}
